module.exports = __webpack_public_path__ + "static/media/logo_branca_sem_fundo_o.ee334a88.png";